<template><svg viewBox="0 0 8 5" xmlns="http://www.w3.org/2000/svg"><path d="M0 1l1-1 3 3 3-3 1 1-4 4z" fill-rule="evenodd"/></svg></template>